import { BankAttachmentResponse } from "types";

export const buildBankAttachmentUrl = (
  attachment: BankAttachmentResponse,
  bankCreditRequestId: number,
) => {
  const { path, id, extension } = attachment;

  if (!path) {
    return undefined;
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const attachmentsBaseUrl = process.env.REACT_APP_API_URL_ATTACHMENTS;
  if (!attachmentsBaseUrl) {
    return path;
  }

  const normalizedBaseUrl = attachmentsBaseUrl.endsWith("/")
    ? attachmentsBaseUrl
    : `${attachmentsBaseUrl}/`;
  const normalizedPath = path.replace(/^\/?uploads\//, "").replace(/^\/+/, "");

  // Some bank attachment responses point only to the request folder.
  // In that case we need to append the stored attachment id and extension.
  const completePath = /\.[a-z0-9]+$/i.test(normalizedPath)
    ? normalizedPath
    : `${normalizedPath.replace(/\/+$/, "")}/${id}.${extension}`;

  return new URL(completePath, normalizedBaseUrl).href;
};
